var EmptyItem = React.createClass({
  render: function() {
    return (
      <div className="item-container">
        <div className="plan-item block bg-primary clearfix">
          <p className="empty-day-msg">Please revise your filter to fill this day.</p>
        </div>
      </div>
    );
  }
});

module.exports = EmptyItem;


// WEBPACK FOOTER //
// ./components/guide-components/empty-item.js